/* Chula — shared wallet row behaviour
 *
 * Extracted from snippets/chula-wallets-styles.liquid on 2026-09-20.
 *
 * It was an inline <script>: re-sent and re-parsed on every page, never
 * cached. As an asset it is fetched once, cached for the session, and
 * `defer` keeps it off the parser's critical path. Deferred scripts run
 * BEFORE DOMContentLoaded, so any global defined here still exists by the
 * time the handlers and DOMContentLoaded callers that use it run.
 */

(function () {
    'use strict';

    if (window.chulaWalletsBound) return;
    window.chulaWalletsBound = true;

    var OPEN_MS = 620;

    /* ── Apple Pay placeholder lifecycle ──────────────────────────────
       Hidden on SHOP CONFIGURATION, never on whether a button rendered.
       Apple Pay only renders on Safari and iOS, so a "is there an apple
       pay button?" test would leave every Chrome and Android shopper
       looking at the placeholder forever once Apple Pay was actually live.

       `wallet-configs` on the cart element is the full list of configured
       wallets and is present regardless of device; the PDP element only
       carries `recommended`/`fallback`, so those are read too. Any page
       with a cart drawer has the cart element available even on a PDP. */
    function walletNames() {
      var names = [];
      document.querySelectorAll(
        'shopify-accelerated-checkout, shopify-accelerated-checkout-cart'
      ).forEach(function (el) {
        ['wallet-configs', 'recommended', 'fallback'].forEach(function (attr) {
          var raw = el.getAttribute(attr);
          if (!raw) return;
          try {
            var parsed = JSON.parse(raw);
            (Array.isArray(parsed) ? parsed : [parsed]).forEach(function (w) {
              if (w && w.name) names.push(String(w.name));
            });
          } catch (e) {}
        });
      });
      return names;
    }

    function syncPlaceholders() {
      var names = walletNames();
      /* Only act on a positive reading. An empty list means the elements
         have not been stamped yet, not that Apple Pay is unconfigured —
         removing on that would flicker the placeholder out and back. */
      if (!names.length) return;
      if (names.indexOf('apple_pay') < 0) return;

      document.querySelectorAll('[data-chula-wallet-soon="apple_pay"]').forEach(function (b) {
        b.remove();
      });
      document.querySelectorAll('[data-chula-wallets-hint]').forEach(function (h) {
        h.hidden = true;
      });
    }

    syncPlaceholders();
    document.addEventListener('DOMContentLoaded', syncPlaceholders);
    window.setTimeout(syncPlaceholders, 1200);

    /* Delegated: every one of these surfaces re-renders its own markup —
       the PDP block on each variant change, the cart on every quantity
       change — so nothing may hold an element reference. */
    document.addEventListener('click', function (e) {
      var soon = e.target.closest('[data-chula-wallet-soon]');
      if (soon) {
        e.preventDefault();
        var row = soon.closest('[data-chula-wallets]');
        var hint = row && row.querySelector('[data-chula-wallets-hint]');
        if (hint) hint.hidden = false;
      }
    });

    /* ── PDP express disclosure ───────────────────────────────────────
       The wrapper's height is animated between two MEASURED values. It is
       not a hardcoded pair: the open height varies with whether the two
       wallets fit side by side, and it grows again the day Apple Pay joins
       PayPal inside Shopify's own block.

       Reflow is forced with `void el.offsetHeight`, never rAF — rAF does
       not fire in a hidden or throttled tab, and gating a panel's visible
       state on it can leave the page behind a fully transparent overlay.
       `transitionend` is not trusted either (it never fires in a hidden
       tab); a timeout releases the height instead. */
    function setHeight(wrap, px) { wrap.style.blockSize = px + 'px'; }

    function releaseHeight(wrap) {
      window.setTimeout(function () {
        if (wrap.getAttribute('data-chula-anim') !== '1') return;
        wrap.removeAttribute('data-chula-anim');
        wrap.style.blockSize = '';
      }, OPEN_MS);
    }

    function openExpress(wrap) {
      var toggle = wrap.querySelector('[data-chula-express-toggle]');
      var panel = wrap.querySelector('[data-chula-express-wallets]');
      if (!panel) return;

      setHeight(wrap, wrap.offsetHeight);
      wrap.setAttribute('data-chula-anim', '1');

      panel.hidden = false;
      wrap.setAttribute('data-open', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');

      void wrap.offsetHeight;
      setHeight(wrap, panel.offsetHeight);
      releaseHeight(wrap);

      /* Shopify may still be waiting to mount, or may have mounted into
         the closed box; this is a no-op when it is already up. */
      try { if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init(); } catch (err) {}
    }

    function closeExpress(wrap) {
      var toggle = wrap.querySelector('[data-chula-express-toggle]');
      var panel = wrap.querySelector('[data-chula-express-wallets]');
      if (!panel) return;

      setHeight(wrap, wrap.offsetHeight);
      wrap.setAttribute('data-chula-anim', '1');

      panel.hidden = true;
      wrap.removeAttribute('data-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');

      void wrap.offsetHeight;
      setHeight(wrap, toggle ? toggle.offsetHeight : 0);
      releaseHeight(wrap);

      /* Return focus to the opener, not to whatever was stashed: a click
         does not focus a button on macOS Safari, so a stash can be <body>.
         preventScroll, or the page jumps. */
      if (toggle) { try { toggle.focus({ preventScroll: true }); } catch (err) {} }
    }

    /* ── The express row starts CLOSED on every width ──────────────────
       It used to open itself on load below 700px, on the reasoning that a phone
       should not cost a tap to discover that PayPal exists. The merchant asked for
       that removed on 2026-10-01: the row is to read "Express checkout" first and
       expand on tap, the same as desktop, on every product.

       Nothing replaces it — `hidden` on the panel is the markup's own default, so
       the closed state is simply allowed to stand. Note what that default is NOT:
       `.chula-express__split[hidden]` is `position: absolute; visibility: hidden`
       with real dimensions, never `display: none`, because Shopify measures the
       PayPal button's container once at mount and never re-measures. The wallet
       still mounts at full size behind the closed panel and is correct the moment
       it is opened — which is exactly why starting closed is safe here. See the
       note on that rule in chula-panels.css before changing any of it. */

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-chula-express-toggle]');
      if (t) {
        var w = t.closest('[data-chula-express]');
        if (w) openExpress(w);
        return;
      }
      var c = e.target.closest('[data-chula-express-close]');
      if (c) {
        var w2 = c.closest('[data-chula-express]');
        if (w2) closeExpress(w2);
      }
    });

    /* Escape does what the × does, for anyone who opened this from the
       keyboard and does not want to tab to the square to get back. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var open = document.querySelector('[data-chula-express][data-open]');
      if (!open) return;
      if (!open.contains(document.activeElement)) return;
      closeExpress(open);
    });
  })();
